import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { hasPermission } from "../../../shared/utils/permissions";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/admin/users")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: ({ context }) => {
    if (!hasPermission(context.auth.user, "admin.users.write")) {
      throw redirect({ to: "/app" });
    }
  },
  component: () => <Outlet />,
});
